<template>
  <DesktopCouponView v-if="isDesktop" />
  <MobileCouponView v-else />
</template>

<script>
import { useScreenSize } from '@/utils/isDesktop'

import DesktopCouponView from './DesktopCouponView'
import MobileCouponView from './MobileCouponView'

export default {
  name: 'CouponViewEntry',
  components: {
    DesktopCouponView,
    MobileCouponView,
  },
  setup() {
    const { isDesktop } = useScreenSize()

    return {
      isDesktop,
    }
  }
}
</script>
